<template>
  <v-card
    class="card d-flex flex-column gap pb-3 pl-3 pr-3"
    outlined
    :loading="pumpMoto.loading"
    :class="{
      'border-yellow': !pumpMoto.loading && !conection(pumpMoto),
      'border-green': !pumpMoto.loading && conection(pumpMoto) && on(pumpMoto),
      'border-red': !pumpMoto.loading && conection(pumpMoto) && !on(pumpMoto),
      'white-bg': !$vuetify.theme.isDark,
      'gray-bg': $vuetify.theme.isDark
    } "
  >
    <div class="d-flex mt-3">
      <v-col cols="1">
        <v-checkbox v-model="pumpMoto.checkbox" @change="onToggleSelected(pumpMoto)" class="mt-2 mr-0"></v-checkbox>
      </v-col>
      <v-col cols="1">
        <v-tooltip right max-width="300px">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on" class="mt-4 ml-0">mdi-help-circle-outline</v-icon>
          </template>
          <span>
            Para realizar um acionamento em conjunto, marque a caixa de seleção 
            <br/>
            em cada conjunto desejado para alterar seu estado de ativação para ligado ou desligado.
          </span>
        </v-tooltip>
      </v-col>
      
      <v-col>
        <div
          class="font-weight-medium text-center text-subtitle-1"
          :class="{
            'grey--text text--darken-4': $vuetify.theme.isDark
          }"
        >
          Conjunto Moto-Bomba {{ index + 1 }} {{isAdmin() ? `(${pumpMoto.id})` : ''}}
        </div>
        <div class="text-caption font-weight-thin text-center">
          {{ engineName }} / {{ pumpName }}
        </div>
      </v-col>
    </div>

    <template>
      <div class="pa-4">
        <!-- Último evento -->
        <div class="mb-4">
          <template v-if="events[pumpMoto.id]">
            <div class="d-flex align-center justify-center text-center">
              <div>
                <div class="font-weight-medium text-subtitle-2">
                  Última mudança no conjunto:
                </div>
                <div
                  class="grey--text text--darken-1"
                  :class="{
                    'text--darken-4': $vuetify.theme.isDark
                  }"
                >
                  {{ dayjs(events[pumpMoto.id].created_date).format("DD/MM/YYYY HH:mm") }}
                </div>
              </div>

              <v-tooltip right max-width="300px">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                    color="grey darken-1"
                  >
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{ events[pumpMoto.id].description }}</span>
              </v-tooltip>
            </div>
          </template>
          <template v-else>
            <div
              class="text-center grey--text text--darken-1"
              :class="{
                'text--darken-4': $vuetify.theme.isDark
              }"
            >
              Este conjunto ainda não possui eventos de acionamento.
            </div>
          </template>
        </div>

        <v-divider class="my-4"></v-divider>

        <!-- Estado e Acionamento -->
        <v-row dense>
          <v-col cols="6">
            <v-sheet
              class="pa-4 lighten-5 grey rounded-lg text-center"
              :class="{
                'grey lighten-1': $vuetify.theme.isDark
              }"
            >
              <div
                class="font-weight-medium text-subtitle-2"
                :class="{
                  'grey lighten-1': $vuetify.theme.isDark
                }"
              >
                Estado Atual
              </div>
              <div
                class="font-weight-bold text-body-1"
                :class="on(pumpMoto) ? 'green--text text--darken-2' : 'red--text text--darken-2'"
              >
                {{ on(pumpMoto) ? 'Ligado' : 'Desligado' }}
              </div>
            </v-sheet>
          </v-col>

          <v-col cols="6">
            <v-sheet
              class="pa-4 grey lighten-5 rounded-lg text-center"
              :class="{
                'grey lighten-1': $vuetify.theme.isDark
              }"
            >
              <div class="font-weight-medium text-subtitle-2">Acionamento</div>
              <div class="font-weight-bold text-body-1">
                {{ pumpMoto.remoteControl ? 'Remoto' : 'Local' }}
              </div>
            </v-sheet>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <!-- Botão principal -->
        <div class="text-center">
          <v-btn
            color="primary"
            large
            depressed
            :disabled="pumpMoto.loading || pumpMoto.isButtonDisabled"
            @click="onClick(pumpMoto)"
          >
            <template v-if="pumpMoto.loading">
              <v-icon class="mr-2 rotate" color="grey">mdi-loading</v-icon>
              {{ on(pumpMoto) ? 'Desligando...' : 'Ligando...' }}
            </template>
            <template v-else>
              {{ pumpMoto.Status === 0 ? 'Ligar' : 'Desligar' }}
            </template>
          </v-btn>
        </div>
      </div>
    </template>

    <div class="card__notification d-flex align-center justify-center flex-column gap">
      <div
        class="pt-3 d-flex align-center justify-center text-subtitle-2"
        :class="{
          'grey--text text--darken-4': $vuetify.theme.isDark
        }"
        v-if="!conection(pumpMoto)"
      >
        <v-icon class="mr-2" color="yellow">mdi-alert</v-icon>
        Falha na comunicação
      </div>
      <div
        class="pt-3 d-flex align-center justify-center text-subtitle-2"
        :class="{
          'grey--text text--darken-4': $vuetify.theme.isDark
        }"
        v-else
      >
        <v-icon class="mr-2" color="green">mdi-check</v-icon>
        Comunicação OK
      </div>
    </div>
  </v-card>
</template>

<script>
import { isAdmin } from '@/core/domain/model/jwtAuthToken';
import { STATUS } from '@/module/pump_moto/domain/model/pump_moto';

export default {
  name: 'PumpMotoCard',
  props: {
    pumpMoto: {
      type: Object,
      required: true
    },
    events: {
      type: Object,
      required: false,
      default: {}
    },
    onToggleSelected: {
      type: Function,
      required: true
    },
    onClick: {
      type: Function,
      required: true
    },
    index: {
      type: Number,
      required: true
    },

    // TODO: validate if this is the best way to handle these names
    engineName: {
      type: String,
      required: true
    },
    pumpName: {
      type: String,
      required: true
    },
  },
  methods: {
    conection: item => item.withPump,
    on: item => item.Status === STATUS.ACTIVE
  }
}
</script>

<style>
.card {
  max-width: 350px;
}
.card__subtitle {
  display: flex;
  justify-content: space-between;
}
.card__actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
}
.card__notification {
  border-top: 1px solid rgb(69, 69, 69);
}
.gap {
  gap: 1rem;
}
.border-green {
  border: 2px solid green !important;
}
.border-red {
  border: 2px solid red !important;
}
.border-yellow {
  border: 2px solid rgb(250, 206, 45) !important;
}
.gray-bg {
  background-color: rgb(210, 210, 210) !important;
}
.rotate {
  animation: spin 1.2s linear infinite;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
.v-tooltip__content {
    background-color: #1b1b1b;
    color: #fff;
    padding: 8px;
    font-size: 14px;
    border-radius: 8px;
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
